import { Table } from '@mantine/core'
import dayjs from 'dayjs'
import { Category } from 'types/products'
import { ShortageOrderTableItem } from 'types/shortage'
import { getCategoryName, getUnitName } from 'utils'

type Props = {
  shortageOrder: ShortageOrderTableItem
}

export default function ShortageOrderInfo({ shortageOrder }: Props) {
  const unit = getUnitName(shortageOrder.unit).short
  return (
    <Table variant="vertical" withTableBorder>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th>Symbol produktu</Table.Th>
          <Table.Td>{shortageOrder.product.symbol}</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Rodzaj produktu</Table.Th>
          <Table.Td>{getCategoryName(shortageOrder.category, { capitalize: true }).mianownik}</Table.Td>
        </Table.Tr>
        {shortageOrder.feature && (
          <Table.Tr>
            <Table.Th>Cecha</Table.Th>
            <Table.Td>{shortageOrder.feature}</Table.Td>
          </Table.Tr>
        )}
        <Table.Tr>
          <Table.Th>{getSizeLabel(shortageOrder.category)}</Table.Th>
          <Table.Td>{shortageOrder.size} cm</Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Zapotrzebowanie</Table.Th>
          <Table.Td>
            {shortageOrder.shortageAmount} {unit}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Th>Zamówiona ilość</Table.Th>
          <Table.Td>
            {shortageOrder.orderedAmount} {unit}
          </Table.Td>
        </Table.Tr>
        {shortageOrder.fulfilledAmount && (
          <Table.Tr>
            <Table.Th>Zrealizowana ilość</Table.Th>
            <Table.Td>
              {shortageOrder.fulfilledAmount} {unit}
            </Table.Td>
          </Table.Tr>
        )}
        {shortageOrder.manufacturer && (
          <Table.Tr>
            <Table.Th>Producent</Table.Th>
            <Table.Td>{shortageOrder.manufacturer.name}</Table.Td>
          </Table.Tr>
        )}
        <Table.Tr>
          <Table.Th>Data stworzenia</Table.Th>
          <Table.Td>{dayjs(shortageOrder.createdAt).format('DD MMMM YYYY')}</Table.Td>
        </Table.Tr>
        {shortageOrder.fulfilledAt && (
          <Table.Tr>
            <Table.Th>Data zrealizowania</Table.Th>
            <Table.Td>{dayjs(shortageOrder.fulfilledAt).format('DD MMMM YYYY')}</Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  )
}

function getSizeLabel(category: Category) {
  switch (category) {
    case Category.FABRIC:
      return 'Szerokość'
    case Category.PREMADE:
      return 'Wymiar'
    default:
      return 'Rozmiar'
  }
}
